import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    overflow: scroll;
    @media (display-mode: browser) {
      overflow: auto;
    }
    ::-webkit-scrollbar {
      width: 0px;
    }
  `,
  card: css`
    min-width: auto;
    height: 26px;
    margin: 5px;
    padding: 4px 8px 4px 8px;
    gap: 2px;
    display: flex;
    align-items: center;
    border: 1px solid ${colors.prussian};
    border-radius: 10px;
    cursor: pointer;
  `,
  free: css`
    background-color: ${colors.prussian300};
    border: none !important;
    svg {
      color: ${colors.prussian};
    }
  `,
  text: css`
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    color: ${colors.prussian};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  logo: css`
    height: 32px;
    width: 32px;
    margin-right: 3px;
  `,
};

export default styles;
